<template>
  <div class="">
    <Modal
      v-model="OpentheProjectModal"
      width="600"
      :title="ProjectsTitle"
      :mask-closable="false"
      :loading="loading"
      @on-ok="ProjectsUpRecList()"
    >
      <Form
        ref="ProjectsForm"
        :model="ProjectsForm"
        :label-width="120"
        label-position="left"
      >
        <FormItem label="企业项目管理">
          <RadioGroup v-model="ProjectsForm.radio">
            <Radio label="1">开通</Radio>
            <Radio label="0">关闭</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          label="过期时间"
          v-show="ProjectsForm.radio === '1'"
        >
          <SmyDatePicker
            transfer
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="请选择过期时间"
            style="width: 100%"
            :options="dateDisabledOptions"
            :value="ProjectsForm.data"
            @input="ProjectsForm.data = $event"
          />
        </FormItem>
				<FormItem label="项目模板数"  v-show="ProjectsForm.radio === '1'">
          <InputNumber :max="10" :min="1" placeholder="请输入项目模板数" v-model="ProjectsForm.pronum" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UpLoadImg from '@/components/UploadImg'
import SmyDatePicker from '@/components/SmyDatePicker'
import { followUpType } from '@/assets/globalData'

export default {
  components: {
    UpLoadImg,
    SmyDatePicker
  },
  props: {
    agentId: {
      type: Number
    },
    ProjectsTitle: {
      type: String
    },
    OpentheProjectsModal: {
      type: Boolean,
      required: true
    },
    ProjectsRow: {
      type: Object
    }
  },
  data() {
    return {
      loading: true,
      multiple: true,
      num: 6,
      override: true,
      OpentheProjectModal: this.OpentheProjectsModal,
      ProjectsForm: {
        epId: '',
        pronum: 0,
        data: '',
        radio: ''
      },
      typeList: followUpType,
      // 日期配置 （无法选择今日之前的日期）
      dateDisabledOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      }
    }
  },
  methods: {
    // 保存编辑数据
    ProjectsUpRecList() {
			let data = {}
      let url = ''
			if (this.ProjectsForm.radio === '') {
				return this.$Message.error('请选择开通或者关闭')
			}
			if (this.ProjectsForm.radio === '1') {
				if (this.ProjectsForm.data === '') {
					return this.$Message.error('请填写过期时间')
				}
				if (this.ProjectsForm.pronum === '') {
					return this.$Message.error('请填写模板数量')
				}
				url = '/enterprise/mgr/project/open'
				data = {
					id: this.ProjectsForm.epId,
					is_enable_project_mgr: this.ProjectsForm.radio === '1' ? 1 : 0,
					project_mgr_service_stop_time: this.ProjectsForm.data,
					project_tmpl_limit_num: this.ProjectsForm.pronum
				}
			} else {
			// 关闭数据空 0
				url = '/enterprise/mgr/project/close'
				data = {
					id: this.ProjectsForm.epId,
					is_enable_project_mgr: 0,
					project_mgr_service_stop_time: '',
					project_tmpl_limit_num: 0
				}
			}
      this.$http.post(url, data).then(res => {
        if (res.success) {
          let msg = '保存成功'
          this.$Message.success(msg)
          this.OpentheProjectModal = false
          this.$emit('callback')
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    reload() {
			// 获取状态
			this.$http
        .get('/enterprise/mgr/project/state', {
          params: {
            id: this.ProjectsRow.id ? this.ProjectsRow.id : this.ProjectsRow.fk_t_enterprise_id
          }
        }).then(res => {
					if (res.success) {
						this.ProjectsForm.radio = (res.data.is_enable_project_mgr).toString()
						this.ProjectsForm.data = res.data.project_mgr_service_stop_time || ''
						this.ProjectsForm.pronum = res.data.project_tmpl_limit_num || 0
					} else {
						this.ProjectsForm.radio = ''
						this.ProjectsForm.data = ''
						this.ProjectsForm.pronum = 0
					}
				})
      this.ProjectsForm.epId = this.ProjectsRow.id ? this.ProjectsRow.id : this.ProjectsRow.fk_t_enterprise_id
    }
  },
  watch: {
    OpentheProjectsModal(val) {
      this.OpentheProjectModal = val
      if (val) {
        this.reload()
      }
    },
    OpentheProjectModal(val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/OpentheProjects.vue